// Home page texts (ar), generated from khotoua-web/index.html.
import type { HomeText } from './types';

const ar: HomeText = {
  header: {
    khotouaHomeLabel: "خطوة — الصفحة الرئيسية",
    khotouaLogoAlt: "لوغو خطوة",
    menuLabel: "القائمة",
    mainMenuLabel: "القائمة الرئيسية",
    aboutUs: "من نحن ؟",
    learningContent: "المحتويات التعليمية",
    features: "مميزات التطبيق",
    forSchools: "للمدارس",
    testimonials: "وثقوا بنا",
    plans: "الاشتراكات",
    contact: "تواصل معنا",
    arabicCurrent: "page",
    arabicStyle: {
      color: "#FFFFFF",
      fontWeight: "800",
      textDecoration: "none",
    },
    francaisStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    francaisCurrent: undefined,
    englishStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    englishCurrent: undefined,
    arCurrent: "page",
    arStyle: {
      color: "#FFFFFF",
      fontWeight: "800",
      textDecoration: "none",
    },
    frStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    frCurrent: undefined,
    enStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    enCurrent: undefined,
    parentSpaceSoon: "فضاء الولي....",
    parentSpace: "فضاء الولي",
    getTheApp: "حمّل التطبيق",
  },
  hero: {
    learningThroughPlayAges: "\nعلّموا الأطفال وهم يلعبون · من 5 إلى 12 سنة ",
    wePrepareYourChild: "نُعِدّ طفلك للامتحان… ",
    whileProtectingTheirChildhood: "ونصون طفولته وهويّته.",
    khotouaIsThePerfect: "تطبيق «خُطوة» هو الرّفيق المثاليّ لأطفال المرحلة الابتدائيّة، ليتعلّموا بطريقة ممتعة ومشوّقة.",
    designedByEducationAnd: "صمّمه خبراء في التربية والتكنولوجيا وفق البرامج المدرسيّة الرسميّة وأحدث المقاربات البيداغوجيّة، ليُناسب جيل ألفا: جيلٌ وُلد مع التكنولوجيا… ويتعلّم بلغتها.",
    tryTheFreeDemo: "جرّب العرض التجريبي مجّانًا",
    getTheAppNow: "حمّل التطبيق الآن",
    getItOn: "حمّله من",
    getItOnAppSoon: "قريبًا على App Store",
    getItOnAppgallerySoon: "قريبًا على Huawei AppGallery",
    tryItOn: "جرّبه على",
    theWeb: "نسخة الويب",
    khotouaSCharacterTheAlt: "شخصيّة خطوة: البطل الصغير",
    khotouaSThreePillars: "ركائز خطوة الثلاث",
    learningCulturePlayLabel: "ركائز خطوة: تعليم، ثقافة، لعب",
    learning: "تعليم",
    culture: "ثقافة",
    play: "لعب",
    discoverMoreLabel: "انزل لاكتشاف المزيد",
    discoverMore: "اكتشف المزيد",
  },
  about: {
    aboutUs: "من نحن ؟",
    ltrDir: "rtl",
    aGenerationThatLearns: "جيلٌ يتعلّم بطريقة مختلفة… يستحقّ تطبيقًا مختلفًا.",
    khotouaIsAnEducational: "«خُطوة» تطبيق تعليميّ  يُعيد تصوّر التعلّم في المرحلة الابتدائيّة للأطفال من 5 إلى 12 سنة.",
    generationAlpha: "جيل ألفا · ",
    designedEspecially: "صُمّم خصّيصًا ",
    forGenerationAlpha: "لجيل ألفا",
    aGenerationBornWith: "، جيل وُلد مع الشاشات، يتعلّم ",
    throughImages: "بالصورة",
    movement: "والحركة",
    andInteraction: "والتفاعل",
    andWhoNeedExperiences: "، ويحتاج إلى تجارب تُشبه عالمه وتُخاطب ",
    curiosity: "فضوله",
    byCombiningPlayWith: "وبفضل الجمع بين اللعب وتقنية الواقع المعزّز، يُقدّم «خُطوة» تجربة غامرة وتفاعليّة فريدة: سيناريوهات مليئة بالألعاب ثنائيّة وثلاثيّة الأبعاد، صُمّمت لتنمية المهارات المعرفيّة بطريقة مسلّية ومبدعة، وتُراعي خصوصيّة كلّ طفل، ليتعلّم بمتعة ويتقدّم بثقة.",
    augmentedReality: "واقع معزّز",
    artificialIntelligence: "ذكاء اصطناعي",
    t2d3dGames: "ألعاب 2D / 3D",
    personalisedLearning: "تعلّم شخصي",
    childrenLearningWithVirtualAlt: "أطفال يتعلّمون بالواقع الافتراضي والمعزّز في ساحة المدرسة",
  },
  contents: {
    learningContent: "المحتويات التعليميّة",
    whatShallWeDo: "ماذا سنفعل اليوم ؟",
    thisIsHowThe: "هكذا يستقبل التطبيق طفلك كلّ يوم: «تعليمي» في القلب، وحوله ألعابي، موسوعتي، متجري ومنوعاتي.",
    theKhotouaHomeScreenAlt: "الشاشة الرئيسيّة لتطبيق خطوة: ماذا سنفعل اليوم؟ تعليمي في القلب، وحوله ألعابي، موسوعتي، متجري ومنوعاتي",
    homeScreenSpacesLabel: "فضاءات الصفحة الرئيسيّة",
    myLessons: "تعليمي",
    arabicFrenchEnglishMaths: "العربيّة · Français · English · الرياضيات · الإيقاظ العلمي",
    myGames: "ألعابي",
    challengeAndCreativityAdventures: "مغامرات التحدّي والإبداع",
    myEncyclopedia: "موسوعتي",
    t3dInAugmentedReality: "ثلاثيّة الأبعاد بالواقع المعزّز",
    myShop: "متجري",
    financialLiteracyLearningTo: "ثقافة ماليّة: نحو التحكّم في المصروف",
    myDiscoveries: "منوعاتي",
    discoverAndLearnVideos: "أكتشف وأعرف: فيديوهات، حكايات وقصص",
  },
  demo: {
    insideTheApp: "جولة داخل التطبيق",
    aCompleteSafeWorldDir: "rtl",
    aCompleteSafeWorld: "عالم كامل وآمن… بين يدي طفلك",
    aSeriousGameWhere: "لعبة جادّة يعيشها الطفل ",
    theHero: "كبطل",
    tryTheDemo: "جرّب العرض التجريبي",
    khotouaWelcomeScreenWelcomeAlt: "شاشة الترحيب في تطبيق خطوة: مرحبا بك",
    welcome: "مرحبا بك !",
    learningCulturePlayDiscovery: "تعليم · ثقافة · لعب · اكتشاف — حساب للطفل في دقيقة.",
    chooseYourTermScreenAlt: "شاشة اختر الثلاثي الدراسي",
    inStepWithThe: "على نسق السنة الدراسيّة",
    term1TheAdventure: "الثلاثي الأوّل: بداية المغامرة · الثاني: مواصلة الرحلة · الثالث: نحو القمّة.",
    chooseYourSchoolAdventureAlt: "شاشة اختر مغامرتك الدراسيّة: العربيّة، الفرنسيّة، الإنجليزيّة، الرياضيات، الإيقاظ العلمي، سؤال وجواب",
    chooseYourSchoolAdventure: "اختر مغامرتك الدراسيّة",
    arabicFrenchEnglishMaths: "العربيّة، Français، English، الرياضيات، الإيقاظ العلمي، سؤال وجواب.",
    myGamesScreenMathsAlt: "شاشة ألعابي: لعبة الحساب، إخراج الجسم المحدّد، الذاكرة، الجمع والكورة",
    challengeAndCreativityAdventures: "مغامرات التحدّي والإبداع",
    mentalMathsMemory2048: "لعبة الحساب، الذاكرة، الجمع 2048… نقاط XP وعملات تحفّز على التقدّم.",
    myEncyclopediaScreenInAlt: "شاشة موسوعتي بالواقع المعزّز: عالم الحيوانات، رحلة حول الكواكب، اكتشف جسم الإنسان",
    myEncyclopediaInAugmented: "موسوعتي بالواقع المعزّز",
    theAnimalWorldA: "عالم الحيوانات، رحلة حول الكواكب، اكتشف جسم الإنسان… كتب تنبض بالحياة.",
    myDiscoveriesScreenVideosAlt: "شاشة منوعاتي: فيديوهات، حكايات، قصص",
    myDiscoveriesWhatWill: "منوعاتي: ماذا سأكتشف اليوم ؟",
    videosToWatchAnd: "فيديوهات للمشاهدة والتعلّم، حكايات بودكاست، وقصص جديدة للقراءة.",
    videosScreenIllustratedStoriesAlt: "شاشة الفيديوهات: قصص مصوّرة",
    meaningfulIllustratedStories: "قصص مصوّرة هادفة",
    samiAndTheTwo: "سامي والغول ذو الرأسين، اللقلق المسنّ، الديك المخدوع… قيم تُروى بمتعة.",
    characterDesignScreenWithAlt: "شاشة صمّم شخصيتك مع رصيد النقاط والثقافة الماليّة",
    designYourCharacterAnd: "صمّم شخصيتك وتحدَّ أصدقاءك",
    myBalanceThePrice: "«رصيدك − السعر = سيبقى لك»: نحو ثقافة ماليّة للتحكّم في المصروف اليومي.",
    mapOfTheSustainabilityAlt: "خريطة رحلة الاستدامة عبر القارّات",
    theSustainabilityJourneyAround: "رحلة الاستدامة حول العالم",
    continentAfterContinentChildren: "قارّة بعد قارّة، يكتشف الطفل كوكبه ويتعلّم كيف يحميه.",
  },
  pedagogy: {
    features: "مميزات التطبيق",
    whyDoParentsAnd: "لماذا يختار الأولياء والمربّون خطوة ؟",
    featuresLabel: "مميزات التطبيق",
    contentAlignedWithThe: "محتوى متوافق مع المناهج الدراسيّة",
    overcomingLearningDifficulties: "تذليل صعوبات التعلّم",
    augmentedReality: "الواقع المعزز",
    bloomSTaxonomyOf: "هرم بلوم للأهداف التعليمية",
    whatKhotouaOffersParents: "ما يقدّمه تطبيق خطوة للأولياء",
    yourChildPlaysAnd: "يلعب طفلك… ويتعلّم ما يدرسه في القسم تمامًا.",
    allSubjectsFollowThe: "جميع الموادّ الدراسيّة المُقدّمة تتطابق مع البرنامج الرسميّ للمرحلة الابتدائيّة، درسًا بدرس. وحين نتجاوزه، فذلك لنُثريه ونُعمّق فهم طفلك ونُوسّع معارفه.",
    behindEveryPieceOf: "خلف كلّ محتوى، فريق بيداغوجيّ مختصّ يُصمّم ويُراجع ويُدقّق، حتّى يصل إلى طفلك تعلّمٌ موثوق بأعلى جودة.",
    screenTimeBecomesTime: "وقت الشاشة… صار وقتًا للنجاح المدرسيّ.",
    usefulScreenTimeWith: "وقت شاشة مفيد… وأنت مطمئنّ",
    parentSpace: "فضاء الولي",
    khotouaYourChildS: "تطبيق «خُطوة»: رفيق طفلك نحو تعلّمٍ أيسر وأمتع",
    khotouaStandsOutFor: "يتميّز تطبيق «خُطوة» بقدرته على مساعدة الأطفال الذين يواجهون صعوبات في التعلّم، عبر أنشطة مُكيَّفة خصّيصًا لاحتياجاتهم، تُمكّن الأولياء والمربّين من تقديم الدعم المناسب لكلّ طفل.",
    weKeepImprovingKhotoua: "نعمل باستمرار على تطوير «خُطوة» ليكون رفيقًا موثوقًا يصحب الأطفال في رحلة تعليميّة فريدة وممتعة، يكتشفون فيها قدراتهم ويُطلقون كامل إمكاناتهم، ويتجاوزون صعوباتهم خطوةً بخطوة نحو أفضل النتائج.",
    overcomingDifficultiesIconColouredLabel: "أيقونة تذليل صعوبات التعلّم: درجات ملوّنة يصعدها الطفل خطوة بخطوة نحو النجمة",
    theLessonLeavesThe: "الدرس يخرج من الكتاب… وينبض بالحياة أمام عيني طفلك!",
    withAugmentedRealityLearning: "مع تقنية الواقع المعزّز، يتحوّل التعلّم إلى مغامرة حقيقيّة: كواكب تدور، وحيوانات تتحرّك، وشخصيّات تتكلّم، كلّها مرتبطة بمحاور الدروس. يقترب طفلك منها، ويكتشفها، ويتفاعل معها في عالم ثلاثيّ الأبعاد.",
    becauseWhatChildrenLive: "لأنّ ما يعيشه الطفل بنفسه… لا يُنسى.",
    myEncyclopediaScreenInAlt: "شاشة موسوعتي بالواقع المعزّز: عالم الحيوانات، رحلة حول الكواكب، اكتشف جسم الإنسان",
    learningContentIsBuilt: "المحتويات التعليميّة بُنيت بشكل متدرّج يستند إلى هرم \"بلوم\" إذ:",
    theLearnerExploresKnowledge: "يستكشف المتعلّم المعرفة ويخزّنها بذاكرته ويستحضرها.",
    practisesActivitiesThatEnsure: "يمارس أنشطة تضمن فهْم تلك المعرفة فهما مُكتملا.",
    appliesWhatTheyHave: "يطبّق المكتسب ضمن وضعيات معيشة ويوظّفها توظيفا متدرّجا.",
    analysesTheKnowledgeAnd: "يحلّل المعارف والمهارات المكتسبة ويعيد تركيبها لاستدماجها ضمن منظومته.",
    evaluatesWhatTheyHave: "يقيّم المكتسب، يسند له قيمة ويطلق عليه حكما موضوعيّا.",
    inventsAndCreatesA: "يبتكر ويبدع منتجا يستند إلى المكتسب محتوى وتمشّيات.",
    bloomSTaxonomyIconLabel: "أيقونة هرم بلوم بالعربيّة: التذكّر، الفهم، التطبيق، التحليل، التقييم، الإبداع",
    remember: "التذكّر",
    understand: "الفهم",
    apply: "التطبيق",
    analyse: "التحليل",
    evaluate: "التقييم",
    create: "الإبداع",
    bloomSTaxonomy: "هرم بلوم",
    whatKhotouaOffersParents2: "ما يقدّمه تطبيق «خُطوة» للأولياء",
    youDonTNeed: "أنت لا تحتاج أن تكون معلّمًا… «خُطوة» معك.",
    seeTheirProgress: "ترى تقدّمه بعينيك:",
    whatTheyHaveDone: " ما أنجزه، وما يُتقنه، وأين يحتاج إليك.",
    trustEveryLesson: "تثق في كلّ درس:",
    contentAlignedWithThe2: " محتوى مطابق للبرنامج الرسميّ، صمّمه مختصّون في التربية.",
    followThemFromYour: "تتابعه من فضائك الخاصّ:",
    theParentSpaceBrings: " «فضاء الوليّ» يجمع كلّ ما يخصّ تعلّم طفلك في مكان واحد.",
    peaceOfMindAbout: "تطمئنّ على وقته:",
    aSafeSpaceDesigned: " مساحة آمنة صُمّمت للأطفال، كلّ دقيقة فيها مفيدة.",
    youLoveThemWe: "أنت تُحبّه… ونحن نساعدك على إنجاحه.",
    khotouaMyProfileAndAlt: "شاشة ملفّي الشخصي وفضاء الوليّ في تطبيق خطوة",
    ourTeachingApproach: "مقاربتنا البيداغوجيّة",
    variedLearningContent: "محتويات تعليميّة متنوّعة",
    wePrepareYourChild: "نُعِدّ طفلك للامتحان… ونُعِدّه للحياة.",
    variedEducationalActivitiesAnd: "أنشطة وألعاب تعليميّة متنوّعة",
    linkedToTheOfficial: "مرتبطة بالبرنامج الرسميّ، تساعده على اكتساب المعارف وتوظيفها في حياته اليوميّة.",
    valuesToGrowUp: "قيم يكبر عليها",
    citizenshipRespectForOthers: "المواطنة، واحترام الآخر، وحقوق الإنسان وحقوق الطفل.",
    anEyeOnThe: "عين على العالم",
    theyDiscoverTheIssues: "يكتشف قضايا عصره، من حماية البيئة إلى أهداف التنمية المستدامة، ويستعدّ لمستقبله بثقة.",
    khotoua: "«خُطوة»",
    yourChildSWindow: " نافذة طفلك على عالم يتغيّر… ليكون جزءًا من تغييره.",
    joinUsTodayOn: "انضمّوا إلينا اليوم في رحلة تعليميّة شيّقة وممتعة مع تطبيق \"خُطوة\".",
    helpYourChildrenDiscover: "ساعدوا أطفالكم على اكتشاف مهاراتهم وتحقيق أحلامهم من خلال تعليم مبتكر وشخصيّ.",
    getTheAppNow: "حمّل التطبيق الآن",
    tryTheDemo: "جرّب العرض التجريبي",
  },
  schools: {
    forSchoolsAndInstitutions: "للمدارس والمؤسّسات",
    aPlatformThatAdapts: "منصّة تتكيّف مع برنامج مدرستك",
    withAFlexibleContent: "بفضل نظام إدارة المحتوى المرن (CMS)، تضيف المدرسة أو الوزارة دروسها ولغاتها وقيمها المحلّيّة دون أيّ برمجة. خطوة شريك لمدارس تونسيّة ولشبكة تعتمد نظام كامبريدج.",
    requestADemoFor: "اطلب عرضًا لمدرستك",
    downloadTheBrochure: "حمّل الكتيّب التعريفي",
    customisableContent: "محتوى قابل للتخصيص",
    modulesAddedToFit: "وحدات تُضاف حسب حاجة المؤسّسة.",
    classTracking: "متابعة القسم",
    toBeConfirmedA: "[للتأكيد] لوحة متابعة للمعلّم حسب القسم والتلميذ.",
    multilingual: "متعدّد اللغات",
    arabicFrenchAndEnglish: "العربيّة والفرنسيّة والإنجليزيّة.",
    trainingAndSupport: "تكوين ومرافقة",
    weSupportTeachersIn: "نرافق المعلّمين في إدماج التطبيق في القسم.",
  },
  trust: {
    testimonials: "وثقوا بنا",
    whatDoTeachersSay: "ماذا يقول المعلّمون والمعلّمات ؟",
    inTheAgeOf: "في زمن التكنولوجيا خطوتان ضروريتان، خطوة للمعرفة وخطوة للتكنولوجيا وذاك تطبيق خطوة.",
    habibaRais: "حبيبة الرايس",
    arabicTeacherForBeginners: "مدرّسة العربيّة للمبتدئين",
    funAndLearningOn: "المتعة والتعلم في رحلة فريدة لاستكشاف العالم بطريقة مشوقة ومسلية. هذا هو تطبيق خطوة، المبتكر التونسي الذي يجمع بين الألعاب والتعلم في آن واحد... لتعزيز المفاهيم التعليمية مع تقييم فردي وتقارير تطويرية هنيئا لكم.",
    ayaEnnaoui: "آية النّوي",
    primarySchoolTeacher: "أستاذة المدارس الابتدائية",
    aSolidStepThat: "هي خطوة ثابتة للارتقاء بالمتعلم نحو التميّز وبناء معارفه على أسس صلبة والسموّ به نحو الأفضل والتعلم في جو من الاستمتاع اعتمادا على ما يقدّم له من تمارين تهدف إلى تجويد مكتسباته بطريقة رائعة تقوده إلى التفوّق.",
    najmeddineJarfel: "نجم الدين جرفال",
    retiredSeniorPrimarySchool: "أستاذ مدارس ابتدائيّة فوق الرّتبة مميّز متقاعد",
    modernInnovativeLearningCapsules: "هي بمثابة كبسولات تربوية تعليمية حديثة ومبتكرة متطابقة مع البرامج الرسمية و تمس الذكاءات المميزة لكل متعلم وأنماط تعلمه. فهي تعالج الصعوبات و تنمي المهارات والقدرات للتلميذ مع سهولة في الاستعمال",
    mohamedZiraoui: "محمد زيراوي",
    civicEducationTeacher: "مدرس المعرفة للمدنيين",
    everyBeginningStartsWith: "لكل بداية خطوة أولى. و تطبيق خطوة سيكون الخطوة الأولى نحو التميّز.",
    salmaHabibi: "سالمة الحبيبي",
    seniorPrimarySchoolTeacher: "أستاذ أول فوق الرتبة للمدارس الابتدائية",
    parentsHaveDownloadedKhotoua: "ولي نزّل تطبيق خطوة ...",
  },
  pricing: {
    plans: "الاشتراكات",
    startForFreeAnd: "ابدأ مجّانًا… وواصل مع العائلة",
    termly6MonthsXLabel: "مدّة الاشتراك",
    termly: "ثلاثي",
    t6MonthsX: "سداسي · [-X٪]",
    yearlyX: "سنوي · [-X٪]",
    discovery: "اكتشاف",
    toTryWithYour: "للتجربة مع طفلك",
    t0Tnd: "0 د.ت",
    theDemo: "العرض التجريبي",
    freeActivities: " أنشطة مجّانيّة",
    oneChildProfile: "ملفّ طفل واحد",
    theFirstLessonOf: "الدرس الأول من كل مادة مجاني",
    getTheAppAnd: "حمل التطبيق و جرّب الآن",
    mostPopular: "الأكثر اختيارًا",
    family: "العائلة",
    allOfKhotouaS: "كلّ عوالم خطوة لكلّ الإخوة",
    termlyPriceTnd: "[السعر الثلاثي] د.ت",
    term: "/ الثلاثي",
    allSixLearningSpaces: "كلّ المحتويات التعليميّة الستّة",
    augmentedRealityAndThe: "الواقع المعزّز والموسوعة ثلاثيّة الأبعاد",
    parentSpaceAndProgress: "فضاء الولي والتقارير التطويريّة",
    upToNumberChild: "حتّى [عدد] ملفّات أطفال",
    subscribeNow: "اشترك الآن",
    schoolsAndInstitutions: "المدارس والمؤسّسات",
    forClassesNetworksAnd: "للأقسام والشبكات والوزارات",
    onRequest: "حسب الطلب",
    licencesPerPupilOr: "رخص حسب التلميذ أو المؤسّسة",
    contentManagementSystemCms: "نظام إدارة المحتوى (CMS)",
    teacherTrainingAndSupport: "تكوين ومرافقة المعلّمين",
    talkToOurTeam: "تحدّث مع فريقنا",
  },
  contact: {
    contact: "تواصل معنا",
    takeTheFirstStep: "اخطُ الخطوة الأولى مع خطوة",
    customerService: "خدمة الحرفاء",
    messageUsOnWhatsapp: "راسلنا على واتساب",
    email: "البريد الالكتروني",
    socialMedia: "مواقع التواصل الاجتماعي",
    instagram: "إنستغرام",
    facebook: "فيسبوك",
    tiktok: "تيك توك",
    linkedin: "لينكدإن",
    youtube: "يوتيوب",
    requestADemoLabel: "اطلب عرضًا تجريبيًّا",
    requestADemo: "اطلب عرضًا تجريبيًّا",
    iAmA: "أنا",
    parent: " وليّ",
    school: "مدرسة",
    institutionPartner: " مؤسّسة / شريك",
    fullName: "الاسم واللقب",
    phone: "الهاتف",
    ltrInputStyle: {
      minHeight: "50px",
      borderRadius: "14px",
      border: "1.5px solid #B8C0EA",
      padding: "0 14px",
      textAlign: "right",
    },
    childSSchoolYear: "المستوى الدراسي للطفل",
    chooseAYear: "اختر المستوى…",
    preSchool: "التحضيري",
    primaryYear1: "السنة الأولى ابتدائي",
    primaryYear2: "السنة الثانية ابتدائي",
    primaryYear3: "السنة الثالثة ابتدائي",
    primaryYear4: "السنة الرابعة ابتدائي",
    primaryYear5: "السنة الخامسة ابتدائي",
    primaryYear6: "السنة السادسة ابتدائي",
    schoolName: "اسم المدرسة",
    eGPrivateSchoolPlaceholder: "مثال: مدرسة … الخاصّة",
    institutionName: "اسم المؤسّسة",
    sendMyRequest: "أرسل طلبي",
    fieldsMarkedWith: "الحقول المشار إليها بـ ",
    areRequiredYourData: " إجباريّة. معطياتك سرّيّة. ",
    privacyPolicy: "سياسة الخصوصية",
  },
  footer: {
    yourChildSJourney: "رحلة طفلك نحو النجاح تبدأ بخطوة… فلتكن اليوم!",
    getItOn: "حمّله من",
    getItOnAppSoon: "قريبًا على App Store",
    getItOnAppgallerySoon: "قريبًا على Huawei AppGallery",
    tryItOn: "جرّبه على",
    theWeb: "نسخة الويب",
    khotouaLogoAlt: "لوغو خطوة",
    everyAchievementStartsWith: "لكل إنجاز خطوة...",
    aboutUsLearningContentLabel: "روابط",
    aboutUs: "من نحن ؟",
    learningContent: "المحتويات التعليمية",
    features: "مميزات التطبيق",
    testimonials: "وثقوا بنا",
    termsAndConditionsPrivacyLabel: "معلومات",
    termsAndConditions: "السياسة العامة",
    privacyPolicy: "سياسة الخصوصية",
    contact: "تواصل معنا",
    producedBy: "المنتج المنفذ :",
    dmNovaOfficialWebsiteLabel: "DM NOVA — الموقع الرسمي",
    t2026KhotouaDmNova: "© 2026 خطوة · DM NOVA. جميع الحقوق محفوظة.",
    privacySettings: "إعدادات الخصوصيّة",
  },
  toast: {
    comingSoon: "قريبا …",
    theParentSpaceIs: "فضاء الولي....",
  },
  whatsapp: {
    whatsappLabel: "راسلنا على واتساب",
    whatsapp: "واتساب",
  },
  scrollNext: {
    keepScrollingLabel: "تابع النزول في الصفحة",
  },
};

export default ar;
